import { render, staticRenderFns } from "./SidebarInfoItem.vue?vue&type=template&id=026d02d6&scoped=true&"
import script from "./SidebarInfoItem.vue?vue&type=script&lang=js&"
export * from "./SidebarInfoItem.vue?vue&type=script&lang=js&"
import style0 from "./SidebarInfoItem.vue?vue&type=style&index=0&id=026d02d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026d02d6",
  null
  
)

export default component.exports